var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg029Devices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.84,
    height: 53.51,
    viewBox: "0 0 69.84 53.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #192a40;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_029-devices",
    "data-name": "029-devices",
    transform: "translate(0 -119.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-1",
    d: "M59.415,119.716H3.426A3.43,3.43,0,0,0,0,123.142v37.326a3.43,3.43,0,0,0,3.426,3.426H23.183l-.893,7.144H20.923a1.094,1.094,0,1,0,0,2.187h5.832a1.094,1.094,0,0,0,0-2.187H24.494l.893-7.144h1.367a1.094,1.094,0,0,0,0-2.187H3.426a1.241,1.241,0,0,1-1.239-1.239V156.9H26.755a1.094,1.094,0,1,0,0-2.187H2.187V123.142A1.241,1.241,0,0,1,3.426,121.9H59.415a1.241,1.241,0,0,1,1.239,1.239v23.329a1.094,1.094,0,0,0,2.187,0V123.142a3.43,3.43,0,0,0-3.427-3.426Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-1",
    d: "M464.416,427.558h-16.33a3.43,3.43,0,0,0-3.426,3.426v25.661a3.43,3.43,0,0,0,3.426,3.426h16.33a3.43,3.43,0,0,0,3.426-3.426V430.984A3.43,3.43,0,0,0,464.416,427.558Zm1.239,29.088a1.241,1.241,0,0,1-1.239,1.239h-16.33a1.241,1.241,0,0,1-1.239-1.239v-1.239h18.809v1.239Zm0-3.426H446.847V434.411h18.809v18.809Zm0-21H446.847v-1.239a1.241,1.241,0,0,1,1.239-1.239h16.33a1.241,1.241,0,0,1,1.239,1.239Zm15.091,4.666h-7a3.43,3.43,0,0,0-3.426,3.426v16.33a3.43,3.43,0,0,0,3.426,3.426h7a3.43,3.43,0,0,0,3.426-3.426v-16.33A3.43,3.43,0,0,0,480.746,436.889Zm1.239,19.756a1.241,1.241,0,0,1-1.239,1.239h-7a1.241,1.241,0,0,1-1.239-1.239v-1.239h9.477v1.239Zm0-3.426h-9.477v-9.477h9.477Zm0-11.664h-9.477v-1.239a1.241,1.241,0,0,1,1.239-1.239h7a1.241,1.241,0,0,1,1.239,1.239v1.239Z",
    transform: "translate(-414.333 -286.846)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg029Devices);
export default __webpack_public_path__ + "static/media/029-devices.4c783455b210904545989b2b9e7c38ef.svg";
export { ForwardRef as ReactComponent };